function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Patient-Portal-Signed-In-//-Documents",
  transform: "translate(-625.000000, -363.000000)",
  fill: "#2F68FD",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(625.000000, 355.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,16.0336064 L0,17.7222608 C0,17.8777948 0.122205249,18 0.277739203,18 L1.96639356,18 C2.03860575,18 2.11081794,17.9722261 2.160811,17.9166782 L8.22663519,11.8564088 L6.14359117,9.77336481 L0.0833217609,15.8336342 C0.0277739203,15.8891821 0,15.9558395 0,16.0336064 Z M9.83752257,10.2455215 C10.0541591,10.0288849 10.0541591,9.67893348 9.83752257,9.4622969 L8.5377031,8.16247743 C8.32106652,7.94584086 7.97111512,7.94584086 7.75447854,8.16247743 L6.73795306,9.17900292 L8.82099708,11.2620469 L9.83752257,10.2455215 Z",
  id: "Shape"
}))));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.a65b0060.svg";
export { ForwardRef as ReactComponent };